import $ from "jquery";
import {GPProjectView} from "./gp-projectview.js";

export class GPItem
{
    constructor () {
        this.xShift = 0;

        this.randSizeX = 1;
        this.randSizeY = 1;
        this.randRot = 0;
        this.randH = 0;
        this.randS = 0;
        this.randV = 0;
    }

    setPosition (x,y) {
        this.x = x;
        this.y = y;
    }

    getName () {
        return this.data.name;
    }

    getHeight () {
        return parseInt(this.data.height) * this.randSizeY;
    }

    //Below go the methods for view (should be on associated view object, but for now are merged here)

    createDisplayObject (season, thumb) {
        var that = this;
        var imgSrc;
        if (thumb)
            imgSrc = this.getPathForThumb(season);
        else
            imgSrc = this.getPathForImage(season);

        return new Promise(function(resolve, reject) {
            var imageObj = new Image();

            $(imageObj).one('load', function () {
                that.imageWidth = imageObj.width;
                that.imageHeight = imageObj.height;

                var result = new Konva.Image({
                    draggable: !that.fixedObject,
                    image: imageObj,
                    id: String(that.id),
                    shadowColor: 'black',
                    shadowBlur: 5,
                    shadowEnabled: that.fixedObject
                });

                resolve(result);
            });
            imageObj.src = imgSrc;
        });
    }

    repositionItem () {
        var image = GPProjectView.stage.find('#' + this.id)[0];
        if (!image) return;

        if (this.fixedObject) {
            image.width(this.imageWidth * GPProjectView.sceneScale);
            image.height(this.imageHeight * GPProjectView.sceneScale);
            image.setX(this.x * GPProjectView.sceneScale);
            image.setY(this.y * GPProjectView.sceneScale - this.imageHeight * GPProjectView.sceneScale);
        } else {
            var v = GPProjectView.coordsProjectToView(this.x, this.y);
            var vi = GPProjectView.coordsViewToImagePos(this.x, this.y, v.x, v.y, this.imageWidth, this.imageHeight, this);

            image.width(vi.scale * this.imageWidth * this.randSizeX);
            image.height(vi.scale * this.imageHeight);
            var offsetX = 0;
            this.actualBaseOffset = (vi.scale * this.imageHeight) * this.relativeBaseOffset / GPProjectView.sceneScale;
            if (this.horizontalFlip < 0)
                offsetX = image.width();
            image.setX(vi.x + offsetX + this.xShift * vi.scale);
            image.setY(vi.y);
            if (GPProjectView.reflection) {
                image.setY(vi.y + 2 * image.height());
                image.scaleY(-1);
            } else image.scaleY(1);
            image.scaleX(this.horizontalFlip);
        }

        if (this.adjustment) {
            image.filters([Konva.Filters.HSV]);
            image.hue(this.adjustment.h);
            image.saturation(this.adjustment.s);
            image.value(this.adjustment.v);
        } else if (this.randH || this.randS || this.randV) {
            image.filters([Konva.Filters.HSV]);
            image.hue(this.randH);
            image.saturation(this.randS);
            image.value(this.randV);
        }

        image.rotation(this.randRot);

        image.cache();
        image.drawHitFromCache();
    }

    setHighlight (state) {
        state = !!state;
        var id = this.id;
        var image = GPProjectView.stage.find('#' + id)[0];

        if (image && image.shadowEnabled() !== state) {
            image.shadowEnabled(state);
            image.cache();
            image.drawHitFromCache();
        }
    }

    scaleAccordingToHorizon(projy, sizeY, horizonPos, designWidth) {
        let sy = sizeY ? sizeY : GP.project.sizeY;
        let hp = horizonPos ? horizonPos : GP.project.horizonPos;
        let dw = designWidth ? designWidth : GP.project.designWidth;
        let s = (projy - sy * (1 - hp)) / (hp * sy);
        return s * 12 /dw;
    }

    async redraw () {

    }

    toJSON() {
       return {}
    }
}